import { FieldInputProps } from 'formik'
import Toggle from 'react-toggle'

type TProps = {
  field: FieldInputProps<boolean>
  disabled: boolean
}

const ToggleButton = ({ field, disabled }: TProps) => {
  const { name, onChange, value } = field

  return (
    <Toggle checked={value} icons={false} name={name} onChange={onChange} disabled={disabled} />
  )
}

export default ToggleButton
